import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CommunityService} from '../../api/resources/community/community.service';
import {ToasterService} from '../../global/toaster.service';

@Component({
  selector: 'app-supplier-details',
  templateUrl: './supplier-details.component.html',
  styleUrls: ['./supplier-details.component.scss']
})
export class SupplierDetailsComponent implements OnInit {
  supplier: any;
  sendingRequestToSupplier = false;

  constructor(public activeModal: NgbActiveModal,
              private _router: Router,
              private _communityService: CommunityService,
              private _toasterService: ToasterService) { }

  ngOnInit() {
  }

  chechAvailabilities() {
    this.activeModal.close();
    this._router.navigateByUrl('/partner/' + this.supplier.id);
  }

  sendRequest(supplier: any) {
    this.sendingRequestToSupplier = true;
    this._communityService.sendConnectRequestToSupplier(supplier.id).subscribe(
      () => {
        this._toasterService.showInfo('Request sent to ' + supplier.brand);
      },
      undefined,
      () =>  {
        this.sendingRequestToSupplier = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/supplier-details/supplier-details.component.ts